import { uniq, map } from 'lodash';
import { GeographyType, TripTypes } from '@model/common';

export const hasHolidays = (destination) =>
  destination.type === GeographyType.COUNTRY
    ? !!destination.regions && !!destination.regions.length
    : !!destination.resorts && !!destination.resorts.length;

export const getTripTypes = (destination) =>
  [...(hasHolidays(destination) ? [TripTypes.HOLIDAYS] : [])].concat(uniq(map(destination.tours, 'type')));
